/**
 * Sticky Header Management Class
 *
 * This class manages a sticky header effect on the webpage. It adds or removes a
 * CSS class to the body based on the user's scroll position, enhancing the user
 * experience by keeping the header visible when scrolling down.
 *
 * Properties:
 * - options: Configuration options including the header element and the sticky class name.
 * - data: Internal data tracking the previous scroll position.
 *
 * Functions:
 * - init(): Initializes the sticky header by capturing the initial scroll position and
 *   setting up the scroll event listener.
 * - onScroll(): Handles the scroll event, adding or removing the sticky class based
 *   on the current scroll position relative to the header height.
 *
 * Example:
 * document.addEventListener('DOMContentLoaded', () => new StickyHeader().init());
 */

import Swiper from 'swiper';
const swiperModules = [Virtual, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar, Parallax, Zoom, Controller, A11y, History, HashNavigation, Autoplay, Thumbs, FreeMode, Grid, Manipulation, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCreative, EffectCards];

import { Virtual, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar, Parallax, Zoom, Controller, A11y, History, HashNavigation, Autoplay, Thumbs, FreeMode, Grid, Manipulation, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCreative, EffectCards } from 'swiper/modules';
import '../Scss/styles.scss';






/*START slider*/
if(document.querySelectorAll('.frame-type-sitepackage_textslider').length){
  const imgSlider = document.querySelectorAll('.frame-type-sitepackage_textslider');
  imgSlider.forEach(function(element) {
    const swiperContainer = element.querySelector('.swiper');
    const swiper = new Swiper(swiperContainer, {
      modules: swiperModules,
      slidesPerView:1,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  });
}
/*END slider*/

/*START product-slider*/
if(document.querySelectorAll('.frame-type-sitepackage_productslider').length){
  const productSlider = document.querySelectorAll('.frame-type-sitepackage_productslider');
  productSlider.forEach(function(element) {
    const swiperProductContainer = element.querySelector('.swiper');
    const swiper = new Swiper(swiperProductContainer, {
      modules: swiperModules,
      slidesPerView:1,
      spaceBetween: 15,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1200: {
          slidesPerView: 3
        }
      }
    });
  });
}
/*END product-slider*/

/*START Parallax-Bild*/
if(document.querySelectorAll('.frame-type-sitepackage_headerelement').length){
  const video = document.querySelector('.parallax-bg');
  if (video) {
    window.addEventListener('scroll', () => {
      const scrolled = window.scrollY;
      const speed = 0.4;
      video.style.transform = `translateY(${scrolled * speed}px)`;
    });
  }
}
/*END Parallax-Bild*/


/*START Video*/
function handleVideoButtonClickSingle(e) {
  const parent = this.closest('.modal-content');
  const videoBox =  parent.querySelector('video');
  const iframe = parent.querySelector('iframe');
  if (videoBox) {
    videoBox.pause();
  }
  if (iframe) {
    const src = iframe.src;
    iframe.src = '';
    iframe.src = src;
  }
}

document.querySelectorAll('.frame-type-sitepackage_mediatext').forEach(function(element) {
  const videoButton = element.querySelector('.btn-close');
  if (videoButton) {
    videoButton.addEventListener('click', handleVideoButtonClickSingle);
  }
});

/*END Video*/



document.addEventListener('DOMContentLoaded', function() {
/*START header-element*/
  if(document.querySelectorAll('.frame-type-sitepackage_headerelement').length){
    function updateOffset() {
      const headerImg = document.querySelector('.animation');

      if (headerImg) {
      headerImg.querySelectorAll('img').forEach((img, index, all) => {
        console.log(img.src, img.clientWidth, img.naturalWidth);

        if (index === 0) {

          const w = img.clientWidth;
          all[1].style.setProperty('--img1-width', w + 'px');
        }
      });
      }
    }

    window.addEventListener('resize', updateOffset);
    window.addEventListener('load', updateOffset);
  }

  /*END header-element*/

  /*START Counter*/
  function isInViewport(element) {
    const bounding = element.getBoundingClientRect();
    const elementHeight = bounding.height;

    const visibleTop = Math.max(bounding.top, 0);
    const visibleBottom = Math.min(
      bounding.bottom,
      window.innerHeight || document.documentElement.clientHeight
    );
    const visibleHeight = visibleBottom - visibleTop;

    return visibleHeight >= elementHeight / 2;
  }

  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function functionCounter(param) {
    param.forEach(function(element) {
      const countTo = parseInt(element.getAttribute('data-count'), 10);
      const startCount = parseInt(element.textContent.replace(/\./g, ''), 10) || 0;
      const duration = 3000;
      const startTime = performance.now();

      function updateCounter(timestamp) {
        const progress = timestamp - startTime;

        const currentCount = Math.floor((countTo - startCount) * (progress / duration)) + startCount;
        element.textContent = formatNumberWithCommas(currentCount);

        if (progress < duration) {
          requestAnimationFrame(updateCounter);
        } else {
          element.textContent = formatNumberWithCommas(countTo);
        }
      }

      requestAnimationFrame(updateCounter);
    });
  }

  const counters = document.querySelectorAll('.frame-type-sitepackage_counter');

  counters.forEach(function(counter) {
    const counterValues = counter.querySelectorAll('.counter .counter-value');

    if (isInViewport(counter)) {
      functionCounter(counterValues);
    } else {
      window.addEventListener('scroll', function scrollHandler() {
        if (isInViewport(counter)) {
          functionCounter(counterValues);
          window.removeEventListener('scroll', scrollHandler);
        }
      });
    }
  });
  /*END Counter*/


/*START Navigation logo*/
  const toggler = document.querySelector('.navbar-toggler');
  /*END Navigation logo*/


  /*START Navigation scroll logo*/
  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      if(!logo.classList.contains('scroll')){
        logo.classList.add('scroll');
      }
    } else {
      if(logo.classList.contains('scroll')){
        logo.classList.remove('scroll');
      }
    }
  });
  /*END Navigation scroll logo*/

});

let isLarge = null;
const navItems = document.querySelectorAll('.navbar-nav .nav-item');
const hamburgerBtn = document.querySelector('.hamburgerBtn');
const navMain  = document.querySelector('#navigation-main');
const logo    = document.querySelector('.logo');
function applyDesktopInteractions() {

  document.querySelectorAll('.dropdown-toggle').forEach(toggle => {
    toggle.addEventListener('shown.bs.dropdown', () => {
      if (window.innerWidth <= 1200) return;
      if (!toggle.classList.contains('language')) {
        document.body.classList.add('overflow-hidden');
        logo.classList.add('sm-media');
      }
    });

    toggle.addEventListener('hidden.bs.dropdown', () => {
      if (window.innerWidth <= 1200) return;

      if (!document.querySelector('.dropdown-menu.show')) {
        document.body.classList.remove('overflow-hidden');

        if (hamburgerBtn) {
          hamburgerBtn.setAttribute('aria-expanded', 'false');
        }

        if (window.innerWidth > 1200 && navMain && navMain.classList.contains('show')) {
          navMain.classList.remove('show');
        }

        logo.classList.remove('sm-media');
      }
    });
  });

  const menu = document.querySelector('.navbar-nav .dropdown-menu.show');

  if (!menu) {
    document.body.classList.remove('overflow-hidden');
  }
}

function applyMobileNavigation() {

  navItems.forEach(item => {
    const menu = item.querySelector('.dropdown-menu');
    if (menu && menu.classList.contains('show')) {
      if (hamburgerBtn) {
        hamburgerBtn.setAttribute('aria-expanded', 'true');
      }
      navMain.classList.add('show');
    }
  });
  if (hamburgerBtn) {
    if (hamburgerBtn.getAttribute('aria-expanded') === 'true') {
      document.body.classList.add('overflow-hidden');
    }
    if (!hamburgerBtn.dataset.bound) {
      hamburgerBtn.dataset.bound = 'true';

      hamburgerBtn.addEventListener('click', () => {
        document.body.classList.toggle('overflow-hidden');
        logo.classList.toggle('sm-media');
      });
    }
  }
}

function checkWidth() {
  const nowLarge = window.innerWidth > 1200;
  if (nowLarge !== isLarge) {
    isLarge = nowLarge;
    if (isLarge) {
      applyDesktopInteractions();
    } else {
      applyMobileNavigation();
    }
  }
}


document.addEventListener('DOMContentLoaded', checkWidth);

window.addEventListener('resize', checkWidth);

/*Navigation*/
